export const DASHBOARD_INITIAL_STATE = '[DASHBOARD] set initial state';
export const SET_DASHBOARD_INITIAL_STATE =
  '[DASHBOARD] initialize dashboard state';
export const DASHBOARD_SET_SELECTED_TAB = '[DASHBOARD] set seleted tab';
export const DASHBOARD_SET_DRAWER = '[DASHBOARD] change drawer visibility';
export const DASHBOARD_RESET_SELECTED_TAB = '[DASHBOARD] Reset dashboard';
